var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-card"},[_c('div',{staticClass:"card-login-img"}),_c('div',{staticClass:"logout-form"},[_vm._v(" 登出中... ")])])])
}]

export { render, staticRenderFns }